module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_html.js
// module id = 250
// module chunks = 48 49 50 51